const LINKS = [
  { href: "#signals", label: "快速自检" },
  { href: "#compare", label: "官仿对照" },
  { href: "#steps", label: "五步辨真" },
  { href: "#tactics", label: "常见套路" },
  { href: "#checklist", label: "自查清单" },
  { href: "#faq", label: "常见问题" },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-accent-100/60">
      <div className="wrap py-10 md:py-12">
        <div className="grid gap-8 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-shield-check-line text-lg"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg text-foreground-950">辨真 · 吃瓜官网识别</span>
                <span className="mt-1 text-[11px] tracking-wide text-foreground-600">防伪辨别 · 避坑指南</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-6 text-foreground-700">
              一份面向普通用户的网络安全科普：帮助你识别吃瓜官网真假与仿冒站点，掌握域名核查、备案查询与内容比对等防伪方法，安全上网、远离钓鱼陷阱。
            </p>
          </div>

          <nav aria-label="站内导航">
            <h3 className="font-heading text-base text-foreground-950">快速导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2">
              {LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="inline-flex items-center gap-1.5 text-sm text-foreground-700 hover:text-primary-700">
                    <i className="ri-arrow-right-s-line text-primary-400"></i>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="font-heading text-base text-foreground-950">免责说明</h3>
            <p className="mt-4 text-sm leading-6 text-foreground-700">
              本网站为第三方安全科普页面，并非“吃瓜官网”官方站，也不代表任何平台背书。文中识别方法仅供通用参考，具体请以各平台公布的官方渠道为准。涉及转账与个人信息，请务必多方核实。
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-foreground-700">
              <i className="ri-mail-line text-primary-500"></i>
              <a href="mailto:verify@zhenbian.guide" rel="nofollow" className="hover:text-primary-700">
                verify@zhenbian.guide
              </a>
            </p>
          </div>
        </div>

        <div className="mt-9 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-5 text-xs text-foreground-600 sm:flex-row">
          <p>© 2026 辨真识别指南 · 内容仅供科普参考，请勿用于侵权或误导他人。</p>
          <p className="inline-flex items-center gap-1.5">
            <i className="ri-secure-payment-line text-secondary-700"></i>
            认准官方渠道 · 谨防仿冒
          </p>
        </div>
      </div>
    </footer>
  );
}